import logo from './logo.svg';
import './App.css';
import TherapistDirectory from './TherapistDirectory';

function App() {
  return (
   <TherapistDirectory />
  );
}

export default App;
